<script>
export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        el.classList.add('authentication-page');
        el.classList.add('authentication-bg');
        el.classList.add('authentication-bg-pattern');
        $('.modal').modal('hide');
    },
    methods:{
    }
}
</script>
